import { useMemo } from "react";
import { getUserSettings } from "@/lib/userSettings";
import { translations, type TranslationKey, type Language } from "@/lib/translations";

export function useTranslation() {
  const settings = getUserSettings();
  const lang = (settings.language as Language) || "he";
  
  const t = useMemo(() => {
    return (key: TranslationKey): string => {
      return translations[lang]?.[key] || translations.he[key] || key;
    };
  }, [lang]);
  
  // Hebrew and Arabic are RTL languages
  const isRTL = lang === "he" || lang === "ar";
  const dir = isRTL ? "rtl" : "ltr";
  
  return { t, lang, isRTL, dir };
}
